import React, { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../../ui/button';

const INITIAL_NOTES = [
  {
    id: 'note-1',
    body: 'Use Chase approval as comparable for next LOC submission.',
    tag: 'Important',
    createdAt: 'Jul 01, 2026',
  },
  {
    id: 'note-2',
    body: 'Need business statements before Bank of America follow-up.',
    tag: 'Follow up',
    createdAt: 'Jun 28, 2026',
  },
];

const FundingClientNotesTab = () => {
  const [draft, setDraft] = useState('');
  const [notes, setNotes] = useState(INITIAL_NOTES);

  const handleClear = () => setDraft('');

  const handleSave = () => {
    const trimmed = draft.trim();
    if (!trimmed) {
      toast.error('Write a note first');
      return;
    }
    setNotes((prev) => [
      {
        id: `note-${Date.now()}`,
        body: trimmed,
        tag: 'Advisor note',
        createdAt: new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }),
      },
      ...prev,
    ]);
    setDraft('');
    toast.success('Note saved');
  };

  return (
    <div data-testid="funding-notes-tab">
      <div className="fg-workspace-card">
        <h4>New Advisor Note</h4>
        <p>Add internal notes for lender strategy, client follow-up, and underwriting observations.</p>

        <div className="fg-note-compose">
          <textarea
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Write a note about this client..."
            data-testid="advisor-note-input"
          />
          <div className="mt-3 flex justify-end gap-2">
            <Button variant="outline" className="rounded-xl" onClick={handleClear} type="button">
              Clear
            </Button>
            <Button className="rounded-xl bg-[var(--fg-accent)] hover:bg-[#126b4f]" onClick={handleSave} type="button" data-testid="save-advisor-note">
              Save Note
            </Button>
          </div>
        </div>
      </div>

      <div className="fg-workspace-card mt-4">
        <h4>Advisor Notes</h4>
        <p>Recent notes and internal activity for this selected client.</p>

        <div className="fg-notes-list" data-testid="advisor-notes-list">
          {notes.map((note) => (
            <div key={note.id} className="fg-note-item">
              <div className="fg-item-icon">N</div>
              <div className="fg-item-main">
                <strong>{note.body}</strong>
                <span>{note.createdAt}</span>
              </div>
              <span className="fg-status-pill fg-status-green">{note.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FundingClientNotesTab;
